import { AccessCodeApi } from 'api/AccessCodeApi';
import { backendApiClient } from 'container/backendApiClient';

export const accessCodeApi = new AccessCodeApi(backendApiClient);
